import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const validHashPaths = ['#home', '#skills', '#projects', '#about', '#connect'];

export const useHashRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      
      // If there's a hash but it's not in our valid list
      if (hash && !validHashPaths.includes(hash)) {
        // Remove the invalid hash and redirect to 404
        window.history.replaceState(
          null, 
          '', 
          window.location.pathname
        );
        navigate('/404');
      }
    };

    // Check on mount and hash change
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [navigate, location]);
}; 